import {
    BarcodeOutlined, CustomerServiceOutlined, DashboardOutlined, DoubleRightOutlined,
    EnvironmentOutlined, GlobalOutlined, HistoryOutlined, LockOutlined, ScissorOutlined, SettingOutlined, TeamOutlined, UngroupOutlined,
    WalletOutlined, WhatsAppOutlined
  } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { getItem } from 'utils/tableColumns';
import { PermissionAction } from 'utils/permissions';

interface MenuEntry {
    key: number;
    label: string;
    path?: string;
    icon: JSX.Element;
    resource?: string;
    children?: MenuEntry[];
}

const menuTree: MenuEntry[] = [
    { key: 1, label: "Dashboard", path: "/home", icon: <DashboardOutlined /> },
    {
        key: 2, label: "Codigos", icon: <BarcodeOutlined />, children: [
            { key: 21, label: "Eventos", path: "/coupons", icon: <DoubleRightOutlined />, resource: "promocodes" },
            { key: 22, label: "Hunters", path: "/hunters", icon: <TeamOutlined />, resource: "hunters" },
            { key: 23, label: "Wallets", path: "/wallets", icon: <WalletOutlined />, resource: "wallets" },
        ]
    },
    {
        key: 3, label: "Servicios", icon: <CustomerServiceOutlined />, children: [
            { key: 31, label: "Del Día", path: "/services/day-services", icon: <CustomerServiceOutlined />, resource: "sales" },
            { key: 32, label: "Próximos", path: "/services/nexts", icon: <DoubleRightOutlined />, resource: "sales" },
            { key: 33, label: "Historial", path: "/services/historical", icon: <HistoryOutlined />, resource: "sales" },
        ]
    },
    { key: 5, label: "Bitacora Bot", path: "/bot", icon: <WhatsAppOutlined />, resource: "whatsapp" },
    {
        key: 4, label: "Configuración", icon: <SettingOutlined />, children: [
            { key: 41, label: "Países", path: "/countries", icon: <GlobalOutlined />, resource: "countries" },
            { key: 42, label: "Zonas", path: "/zones", icon: <EnvironmentOutlined />, resource: "zones" },
            { key: 43, label: "Goodlookeros", path: "/goodlooks", icon: <ScissorOutlined />, resource: "employees" },
            { key: 47, label: "Goodlookeros Auth", path: "/goodlooks/auth", icon: <LockOutlined />, resource: "employees" },
            { key: 48, label: "Operadores", path: "/operators", icon: <TeamOutlined />, resource: "users" },
            { key: 49, label: "Roles", path: "/roles", icon: <LockOutlined />, resource: "roles" },
            { key: 44, label: "Categorías", path: "/categories", icon: <UngroupOutlined />, resource: "categories" },
            { key: 45, label: "Productos", path: "/products", icon: <UngroupOutlined />, resource: "sale_items" },
            { key: 46, label: "Banners", path: "/banners", icon: <UngroupOutlined />, resource: "banners" },
        ]
    },
];

export const getMenus = (can: (resource: string, action: PermissionAction) => boolean) => {
    const buildItems = (entries: MenuEntry[]): any[] => (
        entries
            .filter((entry) => !entry.resource || can(entry.resource, "read"))
            .map((entry) => {
                const children = entry.children ? buildItems(entry.children) : undefined;
                if (entry.children && (!children || children.length === 0)) return null;
                const label = entry.path ? <Link to={entry.path}>{entry.label}</Link> : entry.label;
                return getItem(label, entry.key, () => {}, entry.icon, children);
            })
            .filter((item): item is NonNullable<typeof item> => item !== null)
    );
    return buildItems(menuTree);
};
